(function () {
  'use strict';

  var translationsNode = document.getElementById('librum-translations');
  var translations = translationsNode ? JSON.parse(translationsNode.textContent) : {};
  var inventoryNode = document.getElementById('librum-cart-inventory');
  var inventoryLimits = inventoryNode ? JSON.parse(inventoryNode.textContent) : {};
  var body = document.body;
  var activeTrigger = null;
  var cartBackgroundElements = [];
  var searchTimer = null;
  var searchRequest = null;
  var cartPricingRequest = 0;

  function one(selector, root) {
    return (root || document).querySelector(selector);
  }

  function all(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function escapeHtml(value) {
    var node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  }

  function money(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'ka', {
      style: 'currency',
      currency: currency || 'GEL'
    }).format(Number(cents || 0) / 100);
  }

  function imageWithWidth(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function focusableElements(root) {
    return all('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', root)
      .filter(function (element) { return element.offsetParent !== null; });
  }

  function trapFocus(event, root) {
    var focusable = focusableElements(root);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function toast(message) {
    var element = one('[data-toast]');
    if (!element) return;
    element.textContent = message;
    element.classList.add('is-visible');
    window.clearTimeout(toast.timer);
    toast.timer = window.setTimeout(function () {
      element.classList.remove('is-visible');
    }, 2600);
  }

  function request(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) {
          var error = new Error('Request failed');
          error.status = response.status;
          throw error;
        }
        return payload;
      });
    });
  }

  function cartEndpoint(action) {
    var cartUrl = body.dataset.cartUrl || '/cart';
    return cartUrl.replace(/\/$/, '') + '/' + action;
  }

  function updateCartCount(count) {
    all('[data-cart-count]').forEach(function (element) {
      element.textContent = String(count);
      element.dataset.empty = count === 0 ? 'true' : 'false';
    });
  }

  function parseInventoryLimit(value) {
    if (value === '' || value === null || value === undefined) return null;
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? Math.max(0, parsed) : null;
  }

  function registerInventoryLimit(variantId, value) {
    var inventoryLimit = parseInventoryLimit(value);
    if (variantId && inventoryLimit !== null) inventoryLimits[String(variantId)] = inventoryLimit;
  }

  function inventoryLimitFor(variantId) {
    return parseInventoryLimit(inventoryLimits[String(variantId)]);
  }

  function inventoryLimitMessage(inventoryLimit) {
    return (translations.cartInventoryLimit || '').replace('__QUANTITY__', String(inventoryLimit));
  }

  function clampInventoryInput(input, announce) {
    var inventoryLimit = parseInventoryLimit(input.dataset.inventoryLimit || input.max);
    var requestedQuantity = parseInt(input.value, 10);
    if (inventoryLimit === null || !Number.isFinite(requestedQuantity) || requestedQuantity <= inventoryLimit) return false;
    input.value = String(inventoryLimit);
    if (announce) toast(inventoryLimitMessage(inventoryLimit));
    return true;
  }

  function syncQuantityStepper(stepper) {
    if (!stepper) return;
    var input = one('input[type="number"]', stepper);
    if (!input) return;
    var quantity = parseInt(input.value, 10) || 1;
    var minimum = parseInt(input.min, 10) || 1;
    var maximum = parseInventoryLimit(input.max);
    var decrease = one('[data-quantity-decrease], [data-cart-decrease], [data-cart-page-decrease]', stepper);
    var increase = one('[data-quantity-increase], [data-cart-increase], [data-cart-page-increase]', stepper);
    if (decrease) decrease.disabled = quantity <= minimum;
    if (increase) increase.disabled = maximum !== null && quantity >= maximum;
  }

  function cartItemHtml(item, currency) {
    var inventoryLimit = inventoryLimitFor(item.variant_id);
    var inventoryLimited = inventoryLimit !== null;
    var inventoryAttributes = inventoryLimited
      ? ' max="' + inventoryLimit + '" data-inventory-limit="' + inventoryLimit + '" data-inventory-quantity-input'
      : '';
    var inventoryWarning = inventoryLimited && item.quantity > inventoryLimit
      ? '<p class="cart-stock-warning">' + escapeHtml(inventoryLimitMessage(inventoryLimit)) + '</p>'
      : '';
    var image = item.image
      ? '<img src="' + escapeHtml(imageWithWidth(item.image, 160)) + '" alt="" width="80" height="80" loading="lazy">'
      : '';
    return '<div class="cart-item" data-cart-line="' + item.key + '"' + (inventoryLimited ? ' data-inventory-limit="' + inventoryLimit + '"' : '') + '>' +
      image +
      '<div class="cart-item-body">' +
        '<p class="cart-item-title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></p>' +
        '<p class="cart-item-price">' + money(item.final_price, currency) + '</p>' +
        '<div class="cart-item-row">' +
          '<div class="qty-stepper">' +
            '<button type="button" data-cart-decrease aria-label="' + escapeHtml(translations.cartDecrease) + '">−</button>' +
            '<input type="number" inputmode="numeric" min="1"' + inventoryAttributes + ' value="' + item.quantity + '" aria-label="' + escapeHtml(item.product_title) + '">' +
            '<button type="button" data-cart-increase aria-label="' + escapeHtml(translations.cartIncrease) + '"' + (inventoryLimited && item.quantity >= inventoryLimit ? ' disabled' : '') + '>+</button>' +
          '</div>' +
          '<span class="cart-item-line">' + money(item.final_line_price, currency) + '</span>' +
        '</div>' +
        inventoryWarning +
        '<p class="cart-line-status" data-cart-line-status role="status" aria-live="polite"></p>' +
        '<button type="button" class="cart-remove" data-cart-remove>' + escapeHtml(translations.cartRemove) + '</button>' +
      '</div>' +
    '</div>';
  }

  function renderCart(cart) {
    var pricingRequest = ++cartPricingRequest;
    var items = one('[data-cart-items]');
    var foot = one('[data-cart-foot]');
    var total = one('[data-cart-total]', foot);
    var totalLabel = one('[data-cart-total-label]', foot);
    var priceBreakdown = one('[data-cart-price-breakdown]', foot);
    if (!items) return;
    updateCartCount(cart.item_count);
    if (!cart.items.length) {
      items.innerHTML = '<div class="cart-empty-state" data-cart-empty-state>' +
        '<p class="cart-empty-title">' + escapeHtml(translations.cartEmpty) + '</p>' +
        '<p class="cart-empty-note">' + escapeHtml(translations.cartEmptyDescription) + '</p>' +
        '<a class="btn btn-secondary" href="/collections/books">' + escapeHtml(translations.cartBrowseBooks) + '</a>' +
      '</div>';
      if (foot) foot.hidden = true;
      return;
    }
    items.innerHTML = cart.items.map(function (item) {
      return cartItemHtml(item, cart.currency);
    }).join('');
    all('.qty-stepper', items).forEach(syncQuantityStepper);
    if (total) total.textContent = money(cart.total_price, cart.currency);
    if (priceBreakdown) priceBreakdown.hidden = true;
    if (totalLabel) totalLabel.textContent = translations.cartTotal;
    // Fetch Liquid pricing because Ajax cart items do not include compare-at prices.
    // On failure keep the final total; never invent savings from incomplete Ajax data.
    if (foot) foot.hidden = false;
    return request((body.dataset.cartUrl || '/cart') + '?sections=cart-pricing').then(function (sections) {
      if (pricingRequest !== cartPricingRequest || !sections['cart-pricing']) return;
      var fragment = new DOMParser().parseFromString(sections['cart-pricing'], 'text/html');
      var summary = one('[data-cart-summary-content]', fragment);
      var currentSummary = one('[data-cart-summary-content]', foot);
      if (summary && currentSummary) currentSummary.replaceWith(summary);
    }).catch(function () {});
  }

  function loadCart() {
    return request('/cart.js').then(function (cart) {
      return Promise.resolve(renderCart(cart)).then(function () { return cart; });
    });
  }

  function setCartBackgroundInert(isOpen) {
    if (isOpen) {
      cartBackgroundElements = all('body > *').filter(function (element) {
        return !element.matches('[data-cart-drawer], [data-drawer-backdrop], [data-toast], script') && !element.inert;
      });
      cartBackgroundElements.forEach(function (element) { element.inert = true; });
      return;
    }
    cartBackgroundElements.forEach(function (element) { element.inert = false; });
    cartBackgroundElements = [];
  }

  function openCart(trigger) {
    var drawer = one('[data-cart-drawer]');
    var backdrop = one('[data-drawer-backdrop]');
    if (!drawer) return;
    activeTrigger = trigger || document.activeElement;
    loadCart().catch(function () { toast(translations.cartError); });
    drawer.classList.add('is-open');
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    setCartBackgroundInert(true);
    if (backdrop) backdrop.classList.add('is-open');
    var close = one('[data-cart-close]', drawer);
    if (close) close.focus();
  }

  function closeCart() {
    var drawer = one('[data-cart-drawer]');
    var backdrop = one('[data-drawer-backdrop]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    setCartBackgroundInert(false);
    if (backdrop) backdrop.classList.remove('is-open');
    if (activeTrigger) activeTrigger.focus();
  }

  function setCartLineBusy(line, isBusy) {
    if (!line) return;
    if (isBusy) line.setAttribute('aria-busy', 'true');
    else line.removeAttribute('aria-busy');
    all('button, input', line).forEach(function (control) {
      if (isBusy) {
        control.dataset.cartWasDisabled = control.disabled ? 'true' : 'false';
        control.disabled = true;
      } else {
        control.disabled = control.dataset.cartWasDisabled === 'true';
        delete control.dataset.cartWasDisabled;
      }
    });
  }

  function setCartLineStatus(line, message) {
    var status = one('[data-cart-line-status]', line);
    if (!status) return;
    status.textContent = message || '';
    status.dataset.state = message ? 'error' : '';
  }

  function restoreCartLineFocus(key, actionSelector) {
    var updatedLine = all('[data-cart-line]').find(function (line) { return line.dataset.cartLine === key; });
    var target = updatedLine && one(actionSelector, updatedLine);
    if (!target) target = one('[data-cart-empty-state] a, [data-cart-close]', one('[data-cart-drawer]'));
    if (target) target.focus();
  }

  function changeCartLine(line, quantity, inventoryLimit, actionSelector) {
    if (!line || line.getAttribute('aria-busy') === 'true') return Promise.resolve(null);
    var key = line.dataset.cartLine;
    var requestedQuantity = Math.max(0, quantity);
    if (inventoryLimit !== null) {
      if (requestedQuantity > inventoryLimit) toast(inventoryLimitMessage(inventoryLimit));
      requestedQuantity = Math.min(requestedQuantity, inventoryLimit);
    }
    setCartLineStatus(line, '');
    setCartLineBusy(line, true);
    return request('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: requestedQuantity })
    }).then(function (cart) {
      return Promise.resolve(renderCart(cart)).then(function () {
        restoreCartLineFocus(key, actionSelector);
        return cart;
      });
    }).catch(function (error) {
      var message = error && error.status === 422 ? translations.cartInventoryError : translations.cartError;
      setCartLineBusy(line, false);
      setCartLineStatus(line, message);
      toast(message);
      return null;
    });
  }

  function renderCartPage(cart) {
    var currentPage = one('[data-cart-page]');
    if (!currentPage) return null;
    var sectionId = currentPage.dataset.cartSectionId;
    var sectionHtml = cart.sections && cart.sections[sectionId];
    if (!sectionHtml) {
      window.location.reload();
      return null;
    }
    var documentFragment = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var replacement = one('[data-cart-page]', documentFragment);
    if (!replacement) {
      window.location.reload();
      return null;
    }
    currentPage.replaceWith(replacement);
    updateCartCount(cart.item_count);
    all('[data-cart-page-stepper]', replacement).forEach(syncQuantityStepper);
    return replacement;
  }

  function cartPageRequest(action, payload) {
    var page = one('[data-cart-page]');
    if (!page) return Promise.reject(new Error('Cart page not found'));
    var sectionId = page.dataset.cartSectionId;
    payload.sections = [sectionId];
    payload.sections_url = body.dataset.cartUrl || '/cart';
    page.setAttribute('aria-busy', 'true');
    return request(cartEndpoint(action), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (cart) {
      return { cart: cart, page: renderCartPage(cart) };
    }).catch(function (error) {
      page.removeAttribute('aria-busy');
      throw error;
    });
  }

  function setCartDiscountStatus(root, message, state) {
    var status = one('[data-discount-status]', root || document);
    if (!status) return;
    status.textContent = message || '';
    if (state) status.dataset.state = state;
    else status.removeAttribute('data-state');
  }

  function appliedDiscountCodes(root) {
    return all('[data-applied-discount-code]', root || document).map(function (element) {
      return element.dataset.appliedDiscountCode.trim();
    }).filter(Boolean);
  }

  function applyCartDiscount(code) {
    var trimmedCode = code.trim();
    var page = one('[data-cart-page]');
    if (!trimmedCode) {
      setCartDiscountStatus(page, translations.cartDiscountRequired, 'error');
      return;
    }
    var codes = appliedDiscountCodes(page);
    if (!codes.some(function (appliedCode) { return appliedCode.toLowerCase() === trimmedCode.toLowerCase(); })) {
      codes.push(trimmedCode);
    }
    var button = one('[data-discount-apply]', page);
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    setCartDiscountStatus(page, '', null);
    cartPageRequest('update.js', { discount: codes.join(',') }).then(function (result) {
      if (!result.page) return;
      var applied = appliedDiscountCodes(result.page).some(function (appliedCode) {
        return appliedCode.toLowerCase() === trimmedCode.toLowerCase();
      });
      var input = one('[data-discount-code]', result.page);
      if (!applied && input) input.value = trimmedCode;
      setCartDiscountStatus(
        result.page,
        applied ? translations.cartDiscountApplied : translations.cartDiscountInvalid,
        applied ? 'success' : 'error'
      );
    }).catch(function () {
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      setCartDiscountStatus(page, translations.cartDiscountError, 'error');
    });
  }

  function removeCartDiscounts() {
    var page = one('[data-cart-page]');
    var button = one('[data-discount-remove]', page);
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    cartPageRequest('update.js', { discount: '' }).catch(function () {
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      setCartDiscountStatus(page, translations.cartDiscountError, 'error');
    });
  }

  function changeCartPageLine(line, quantity) {
    var inventoryLimit = parseInventoryLimit(line.dataset.inventoryLimit);
    var requestedQuantity = Math.max(1, quantity);
    if (inventoryLimit !== null) {
      if (requestedQuantity > inventoryLimit) toast(inventoryLimitMessage(inventoryLimit));
      requestedQuantity = Math.min(requestedQuantity, inventoryLimit);
    }
    line.setAttribute('aria-busy', 'true');
    cartPageRequest('change.js', {
      id: line.dataset.cartPageLine,
      quantity: requestedQuantity
    }).catch(function (error) {
      line.removeAttribute('aria-busy');
      toast(error && error.status === 422 ? translations.cartInventoryError : translations.cartError);
    });
  }

  function addProduct(form) {
    var data = new FormData(form);
    registerInventoryLimit(data.get('id'), form.dataset.inventoryLimit);
    return request('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data
    }).then(function (item) {
      var message = (translations.cartAdded || '').replace('__TITLE__', item.product_title || '');
      toast(message);
      return loadCart();
    }).catch(function (error) {
      toast(error && error.status === 422 ? translations.cartInventoryError : translations.cartError);
    });
  }

  function closeSearch() {
    var overlay = one('[data-search-overlay]');
    if (!overlay) return;
    window.clearTimeout(searchTimer);
    if (searchRequest) searchRequest.abort();
    searchRequest = null;
    var input = one('[data-search-input]');
    var results = one('[data-search-results]');
    var hint = one('[data-search-hint]');
    if (input) input.value = '';
    if (results) {
      results.innerHTML = '';
      results.removeAttribute('aria-busy');
    }
    if (hint) hint.hidden = false;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('inert', '');
    if (activeTrigger) activeTrigger.focus();
  }

  function openSearch(trigger) {
    var overlay = one('[data-search-overlay]');
    var input = one('[data-search-input]');
    if (!overlay || !input) return;
    activeTrigger = trigger;
    overlay.classList.add('is-open');
    overlay.removeAttribute('inert');
    overlay.setAttribute('aria-hidden', 'false');
    input.focus();
  }

  function renderSearchHtml(html) {
    var results = one('[data-search-results]');
    var hint = one('[data-search-hint]');
    if (!results) return;
    if (hint) hint.hidden = true;
    results.removeAttribute('aria-busy');
    if (!html.trim()) {
      results.innerHTML = '<p class="search-hint">' + escapeHtml(translations.searchNoResults) + '</p>';
      return;
    }
    results.innerHTML = html;
  }

  function inlineSearch(query) {
    var base = body.dataset.searchUrl || '/search';
    if (searchRequest) searchRequest.abort();
    searchRequest = new AbortController();
    fetch(base + '?q=' + encodeURIComponent(query) + '&type=product,page&section_id=search-inline', {
      headers: { Accept: 'text/html' },
      signal: searchRequest.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Search request failed');
        return response.text();
      })
      .then(function (html) {
        searchRequest = null;
        renderSearchHtml(html);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        searchRequest = null;
        renderSearchHtml('');
      });
  }

  function setGalleryImage(index) {
    var thumbs = all('[data-gallery-thumb]');
    var main = one('[data-gallery-main]');
    if (!main || !thumbs[index]) return;
    var thumb = thumbs[index];
    var image = one('img', main);
    if (image) {
      image.src = thumb.dataset.imageUrl;
      image.alt = thumb.dataset.imageAlt || '';
      image.removeAttribute('srcset');
    }
    main.dataset.mediaIndex = String(index);
    thumbs.forEach(function (item, itemIndex) {
      if (itemIndex === index) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
  }

  function openLightbox(index) {
    var lightbox = one('[data-lightbox]');
    var thumb = all('[data-gallery-thumb]')[index];
    var image = one('[data-lightbox-image]');
    if (!lightbox || !thumb || !image) return;
    activeTrigger = document.activeElement;
    lightbox.dataset.mediaIndex = String(index);
    image.src = thumb.dataset.imageUrl;
    image.alt = thumb.dataset.imageAlt || '';
    lightbox.classList.add('is-open');
    lightbox.removeAttribute('inert');
    lightbox.setAttribute('aria-hidden', 'false');
    one('[data-lightbox-close]', lightbox).focus();
  }

  function closeLightbox() {
    var lightbox = one('[data-lightbox]');
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.setAttribute('inert', '');
    if (activeTrigger) activeTrigger.focus();
  }

  function moveLightbox(direction) {
    var lightbox = one('[data-lightbox]');
    var thumbs = all('[data-gallery-thumb]');
    if (!lightbox || !thumbs.length) return;
    var index = parseInt(lightbox.dataset.mediaIndex, 10) || 0;
    index = (index + direction + thumbs.length) % thumbs.length;
    lightbox.dataset.mediaIndex = String(index);
    var image = one('[data-lightbox-image]', lightbox);
    image.src = thumbs[index].dataset.imageUrl;
    image.alt = thumbs[index].dataset.imageAlt || '';
  }

  document.addEventListener('submit', function (event) {
    var quickAdd = event.target.closest('.quick-add-form');
    var productForm = event.target.closest('.product-form-enhanced');
    if (!quickAdd && !productForm) return;
    event.preventDefault();
    addProduct(event.target).then(function (cart) {
      if (cart && productForm) openCart(event.submitter);
    });
  });

  all('form[data-inventory-limit]').forEach(function (form) {
    var variantInput = one('input[name="id"]', form);
    registerInventoryLimit(variantInput && variantInput.value, form.dataset.inventoryLimit);
  });
  all('[data-quantity-stepper]').forEach(syncQuantityStepper);
  all('[data-cart-page-stepper]').forEach(syncQuantityStepper);

  document.addEventListener('click', function (event) {
    var navToggle = event.target.closest('[data-nav-toggle]');
    if (navToggle) {
      var panel = one('[data-mobile-nav]');
      setMobileNavigation(panel && !panel.classList.contains('is-open'), true);
      return;
    }
    if (!event.target.closest('[data-mobile-nav]') || event.target.closest('[data-mobile-nav] a')) setMobileNavigation(false);
    var galleryThumb = event.target.closest('[data-gallery-thumb]');
    if (galleryThumb) { setGalleryImage(parseInt(galleryThumb.dataset.mediaIndex, 10)); return; }
    var galleryMain = event.target.closest('[data-gallery-main]');
    if (galleryMain) { openLightbox(parseInt(galleryMain.dataset.mediaIndex, 10) || 0); return; }
    if (event.target.closest('[data-lightbox-close]') || event.target.matches('[data-lightbox]')) { closeLightbox(); return; }
    if (event.target.closest('[data-lightbox-prev]')) { moveLightbox(-1); return; }
    if (event.target.closest('[data-lightbox-next]')) { moveLightbox(1); return; }
    var cartPageLine = event.target.closest('[data-cart-page-line]');
    if (cartPageLine) {
      var pageInput = one('input[type="number"]', cartPageLine);
      var pageQuantity = parseInt(pageInput.value, 10) || 1;
      if (event.target.closest('[data-cart-page-decrease]')) {
        changeCartPageLine(cartPageLine, pageQuantity - 1);
        return;
      }
      if (event.target.closest('[data-cart-page-increase]')) {
        changeCartPageLine(cartPageLine, pageQuantity + 1);
        return;
      }
    }
    var discountApply = event.target.closest('[data-discount-apply]');
    if (discountApply) {
      var discountPage = discountApply.closest('[data-cart-page]');
      var discountInput = one('[data-discount-code]', discountPage);
      applyCartDiscount(discountInput ? discountInput.value : '');
      return;
    }
    if (event.target.closest('[data-discount-remove]')) {
      removeCartDiscounts();
      return;
    }
    var quantityStepper = event.target.closest('[data-quantity-stepper]');
    if (quantityStepper) {
      var quantityInput = one('input', quantityStepper);
      var currentQuantity = parseInt(quantityInput.value, 10) || 1;
      var maximumQuantity = parseInventoryLimit(quantityInput.max);
      if (event.target.closest('[data-quantity-decrease]')) quantityInput.value = String(Math.max(1, currentQuantity - 1));
      if (event.target.closest('[data-quantity-increase]')) {
        if (maximumQuantity !== null && currentQuantity >= maximumQuantity) toast(inventoryLimitMessage(maximumQuantity));
        quantityInput.value = String(maximumQuantity === null ? currentQuantity + 1 : Math.min(maximumQuantity, currentQuantity + 1));
      }
      syncQuantityStepper(quantityStepper);
      return;
    }
    var cartOpen = event.target.closest('[data-cart-open]');
    if (cartOpen) { openCart(cartOpen); return; }
    if (event.target.closest('[data-cart-close]') || event.target.matches('[data-drawer-backdrop]')) { closeCart(); return; }
    var searchOpen = event.target.closest('[data-search-open]');
    if (searchOpen) { openSearch(searchOpen); return; }
    if (event.target.closest('[data-search-close]') || event.target.matches('[data-search-overlay]')) { closeSearch(); return; }
    var line = event.target.closest('[data-cart-line]');
    if (line) {
      var input = one('input[type="number"]', line);
      var quantity = parseInt(input.value, 10) || 1;
      var inventoryLimit = parseInventoryLimit(line.dataset.inventoryLimit);
      if (event.target.closest('[data-cart-decrease]')) changeCartLine(line, quantity - 1, inventoryLimit, '[data-cart-decrease]');
      if (event.target.closest('[data-cart-increase]')) changeCartLine(line, quantity + 1, inventoryLimit, '[data-cart-increase]');
      if (event.target.closest('[data-cart-remove]')) changeCartLine(line, 0, inventoryLimit, '[data-cart-remove]');
    }
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-inventory-quantity-input]')) return;
    clampInventoryInput(event.target, true);
    syncQuantityStepper(event.target.closest('.qty-stepper'));
  });

  document.addEventListener('change', function (event) {
    var cartPageLine = event.target.closest('[data-cart-page-line]');
    if (cartPageLine && event.target.matches('input[type="number"]')) {
      changeCartPageLine(cartPageLine, parseInt(event.target.value, 10) || 1);
      return;
    }
    var line = event.target.closest('[data-cart-line]');
    if (line && event.target.matches('input[type="number"]')) {
      changeCartLine(
        line,
        parseInt(event.target.value, 10) || 1,
        parseInventoryLimit(line.dataset.inventoryLimit),
        'input[type="number"]'
      );
      return;
    }
    if (event.target.matches('[data-inventory-quantity-input]')) {
      clampInventoryInput(event.target, true);
      syncQuantityStepper(event.target.closest('.qty-stepper'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches('[data-discount-code]')) return;
    event.preventDefault();
    applyCartDiscount(event.target.value);
  });

  var searchInput = one('[data-search-input]');
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      window.clearTimeout(searchTimer);
      var query = searchInput.value.trim();
      if (query.length < 2) {
        if (searchRequest) searchRequest.abort();
        searchRequest = null;
        var results = one('[data-search-results]');
        var hint = one('[data-search-hint]');
        if (results) {
          results.innerHTML = '';
          results.removeAttribute('aria-busy');
        }
        if (hint) hint.hidden = false;
        return;
      }
      var results = one('[data-search-results]');
      var hint = one('[data-search-hint]');
      if (results) {
        results.setAttribute('aria-busy', 'true');
        results.innerHTML = '<p class="search-hint">' + escapeHtml(translations.searchLoading) + '</p>';
      }
      if (hint) hint.hidden = true;
      searchTimer = window.setTimeout(function () { inlineSearch(query); }, 180);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') {
      var activeModal = one('[data-lightbox].is-open') || one('[data-cart-drawer].is-open') || one('[data-search-overlay].is-open');
      if (activeModal) trapFocus(event, activeModal);
      return;
    }
    if (event.key !== 'Escape') return;
    if (one('[data-mobile-nav].is-open')) {
      setMobileNavigation(false, true);
      return;
    }
    closeCart();
    closeSearch();
    closeLightbox();
    setMobileNavigation(false, true);
    if (activeTrigger) activeTrigger.focus();
  });

  // A disclosure, not a modal: keep the page reachable by keyboard while open.
  function setMobileNavigation(open, moveFocus) {
    var panel = one('[data-mobile-nav]');
    var toggle = one('[data-nav-toggle]');
    if (!panel || !toggle) return;
    var wasOpen = panel.classList.contains('is-open');
    if (!open && wasOpen && moveFocus) toggle.focus();
    panel.classList.toggle('is-open', Boolean(open));
    panel.toggleAttribute('inert', !open);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && moveFocus) {
      var firstLink = one('a', panel);
      if (firstLink) firstLink.focus({ preventScroll: true });
    }
  }

  document.addEventListener('focusin', function (event) {
    if (!event.target.closest('[data-mobile-nav], [data-nav-toggle]')) setMobileNavigation(false);
  });
  window.matchMedia('(min-width: 721px)').addEventListener('change', function (event) {
    if (event.matches) setMobileNavigation(false);
  });

  all('[data-auto-submit]').forEach(function (element) {
    element.addEventListener('change', function () { element.form.submit(); });
  });

  loadCart().catch(function () {});
}());
